module.exports = __webpack_public_path__ + "img/subscript.740e9e5f.svg";